import { store, setLoadingScreen } from 'modules';

export function loadingScreen(show = false): void {
  store.dispatch(setLoadingScreen({ show }));
}
